import { Component, inject, Input, OnChanges } from '@angular/core';
import { ProductListByIdsComponent } from 'gung-standard';
import { SjoborgProductListByIdsConfigService } from '../../services/sjoborg-product-list-by-ids-config.service';

@Component({
    selector: 'sjoborg-product-list-by-ids-spare-parts',
    template: '<lib-filter-list #productList [configService]="configService"></lib-filter-list>',
    styleUrls: ['./sjoborg-product-list-by-ids-spare-parts.component.scss'],
    standalone: false
})
export class SjoborgProductListByIdsSparePartsComponent extends ProductListByIdsComponent implements OnChanges {
  public configService = inject(SjoborgProductListByIdsConfigService);
  
  @Input()
  tabType: string;


  constructor() {
    super();
    this.configService.tabType = this.tabType;
  }
  
  ngOnChanges(){
    this.configService.tabType = this.tabType;
  }
}
